import { IControllerType, GroupedEnum, EnumType } from './post.d';

// fallow-ignore-next-line complexity
export const getControllerFromFileName = (
  fileName: string
): IControllerType => {
  const lowerFileName = fileName.toLowerCase();

  if (
    lowerFileName.startsWith('redline_') ||
    lowerFileName.includes('_redline_')
  ) {
    return IControllerType.REDLINE;
  }
  if (lowerFileName.startsWith('masso_') || lowerFileName.includes('_masso_')) {
    return IControllerType.MASSO;
  }
  if (
    lowerFileName.startsWith('buildbotics_') ||
    lowerFileName.includes('_buildbotics_') ||
    lowerFileName.startsWith('buildotics_') ||
    lowerFileName.includes('_buildotics_')
  ) {
    return IControllerType.BUILDOTICS;
  }
  if (lowerFileName.startsWith('other_') || lowerFileName.includes('_other_')) {
    return IControllerType.OTHER;
  }

  if (lowerFileName.endsWith('.ngc') && !lowerFileName.endsWith('.gcode')) {
    return IControllerType.BUILDOTICS;
  }

  return IControllerType.OTHER;
};

/**
 * The controller an attachment belongs to: its own field first, then the
 * filename.
 *
 * Lives in this leaf rather than post.utils because lib/fileType needs it to
 * pick a row's icon, and importing post.utils from lib puts CONTROLLER_CONFIG
 * in a cycle — it resolves to undefined at render time.
 */
export const getAttachmentController = (attachment: {
  controller?: string;
  fileName: string;
}): IControllerType =>
  (attachment.controller as IControllerType) ??
  getControllerFromFileName(attachment.fileName);

export const getGroupedOptionsFlat = (groupedEnum: GroupedEnum): string[] => {
  const flatOptions: string[] = Object.entries(groupedEnum).flatMap(
    ([materialGroupKey, materialEnum]) => {
      const option: string[] = Object.entries(materialEnum as EnumType).map(
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        ([_, value]) => value
      );
      if (materialGroupKey === '[object Object]') {
        return [''];
      }
      return option;
    }
  );

  return flatOptions;
};
